import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { TTicketingUserInvitation } from '../types/ticketing-user.type';

export const ResendInviteAsAdminTicketingUserValidationSchema = z.object({
  invitationId: z.string({ message: 'Invitation ID is required' }).min(1),
});

export type TResendInviteAsAdminTicketingUserValidation = z.infer<
  typeof ResendInviteAsAdminTicketingUserValidationSchema
>;
export type TResendInviteAsAdminTicketingUserInvitationPayload = TResendInviteAsAdminTicketingUserValidation;
export type TResendInviteAsAdminTicketingUserResponse = ApiResponse<TTicketingUserInvitation>;

export const resendInviteAsAdminTicketingUser = async (
  payload: TResendInviteAsAdminTicketingUserInvitationPayload
): Promise<TResendInviteAsAdminTicketingUserResponse> => {
  const url = `/invitation-ticketing/resend/${payload.invitationId}`;

  return axiosInstance.post(url, payload);
};

/**
 * Use Resend Invite As Admin Ticketing User React-Query Hook
 */
type UseResendInviteAsAdminTicketingUserMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof resendInviteAsAdminTicketingUser, AxiosErrorCustom>;
};

/**
 * Use Invite As Admin Ticketing User React-Query Hook
 */
export const useResendInviteAsAdminTicketingUserMutation = ({
  mutationConfig,
}: UseResendInviteAsAdminTicketingUserMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: resendInviteAsAdminTicketingUser,
    ...restConfig,
  });
};
